import { render, staticRenderFns } from "./ManterPeticaoEditar.vue?vue&type=template&id=1f5a24fa&scoped=true&"
import script from "./ManterPeticaoEditar.vue?vue&type=script&lang=js&"
export * from "./ManterPeticaoEditar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5a24fa",
  null
  
)

export default component.exports